import { fixedAssets, desktopAssets } from 'src/containers/PreCache'
import styled from 'styled-components'

export const PageStyle = styled.div`
  background-image: url(${desktopAssets.galleryBg});
  background-size: cover;
  /* padding-top: 30px; // 30px notice bar */
  height: 100vh;
  overflow: scroll;

  // layout -> content -> grid-container OR infinite-scroll-container
  .page-layout {
    height: 100%;
    display: grid;
    grid-template-columns: minmax(280px, 25%) 1fr;
  }

  .page-content {
    /* backdrop-filter: blur(5px); */
    display: grid;
    grid-template-rows: 125px 1fr; // 80px header
    /* padding-right: 65px; // right navbar */
    margin-left: 100%;
    width: calc(100vw - 480px);
    color: #fff;
    background: rgba(64, 62, 59, 0.5);
    backdrop-filter: blur(6px);

    .grid-container {
      display: grid;
      grid-gap: 60px;
      grid-template-columns: repeat(auto-fill, 170px);
      margin: 20px 70px;
      grid-auto-rows: max-content;
    }
    .soon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #569099;
      font-weight: 800;
    }

    // header
    .back-btn {
      font-weight: bold;
      display: flex;
      align-items: center;
      text-decoration: none;
      padding: 20px 30px;

      /* Canonical button style — matches the login page submit button
         (src/pages/LoginPage/LoginPage.tsx '.submit-btn') for visual
         consistency across the app. Scoped to this page only (rather
         than overriding the shared global '.c-button' class in
         src/index.css) so the many other unrelated '.c-button' usages
         elsewhere in the app are left untouched. */
      .c-button {
        background: var(--Gold-Gradient-01);
        color: #fff !important;
        border-radius: 10px;
        box-shadow: 0px 4px 6.15px rgba(0, 0, 0, 0.21);
      }
      .back-icon {
        cursor: pointer;
        display: flex;
        width: 30px;
        flex-direction: column;
        img,
        svg {
          transition: 100ms linear;
          height: 24px;
        }
        .icon-label {
          transition: 100ms linear;
          text-align: left;
          font-size: 1px;
          opacity: 0;
        }
        &:hover {
          img,
          svg {
            transform: scale(0.5);
          }
          .icon-label {
            font-size: 8px;
            opacity: 1;
          }
        }
      }
      span {
        font-size: 24px;
        margin-left: 1em;
        color: #f8c605;
      }
    }
  }

  .card-thumbnail {
    color: #fff !important;
  }

  .page-sidebar {
    color: #f8c605;
    font-size: 20px;
    padding: 0;
    width: 25%;
    position: fixed;
    height: 100vh;
    /* background-color: #F8C605; */

    display: flex;
    flex-direction: column;

    .page-title {
      padding: 20px 30px;
      background: #000;
      width: 100%;
      h2 {
        text-align: center;
        font-weight: 600;
        font-size: 35px;
        margin: 0;
      }
    }

    .intro {
      margin-top: 5%;

      img {
        margin-bottom: 8rem;
      }
    }
  }

  .organizer-header {
    background: #fff;
    display: inline-flex;
    align-items: center;
    padding: 9px;
    gap: 1rem;
    border-bottom-right-radius: 10px;
    margin-bottom: 1rem;
    align-self: start;
    position: absolute;
    top: 0;

    p {
      margin: 0;
      font-size: 8px;
      font-weight: 500;
      letter-spacing: 0.24px;
      color: #000;
    }

    img {
      max-width: 106px;
    }
  }

  .card-thumbnail {
    display: block;
    cursor: pointer;
    position: relative;
    text-align: center;
    color: #525252;
    font-weight: 500;
    text-decoration: none;
    font-size: 16px;
    img {
      transition: 150ms ease-in;
    }

    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
`
